import { Injectable } from '@angular/core';

import { EChartsOptions } from './echarts-options';

export type OptionDelegate = (options: EChartsOptions) => void;

@Injectable()
export class EChartsService {


  private myECharts: any;

  public setCharts(value: any): void {
    this.myECharts = value;
  }

  public getECharts(): any {
    return this.myECharts;
  }

  public setOption(option: EChartsOptions, notMerge?: boolean, lazyUpdate?: boolean): void {
    this.myECharts.setOption(option, notMerge, lazyUpdate);
  }

  public getWidth(): number {
    return this.myECharts.getWidth();
  }

  public getHeight(): number {
    return this.myECharts.getHeight();
  }

  public getDom(): HTMLCanvasElement | HTMLDivElement {
    return this.myECharts.getDom();
  }

  public getOption(): EChartsOptions {
    return this.myECharts.getOption();
  }

  public resize(): void {
    this.myECharts.resize();
  }

  public dispatchAction(payload: Object): void {
    this.myECharts.dispatchAction(payload);
  }

  public on(eventName: string, handler: Function, context?: Object): void {
    this.myECharts.on(eventName, handler, context);
  }

  public off(eventName: string, handler?: Function): void {
    this.myECharts.off(eventName, handler);
  }

  public convertToPixel(finder: {
    seriesIndex?: number,
    seriesId?: string,
    seriesName?: string,
    geoIndex?: number,
    geoId?: string,
    geoName?: string,
    xAxisIndex?: number,
    xAxisId?: string,
    xAxisName?: string,
    yAxisIndex?: number,
    yAxisId?: string,
    yAxisName?: string,
    gridIndex?: number,
    gridId?: string
    gridName?: string
  } | string,
    // 要被转换的值。
    // 转换的结果为像素坐标值，以 echarts 实例的 dom 节点的左上角为坐标 [0, 0] 点。)
    value: Array<any> | string): Array<any> | string {
    return this.myECharts.convertToPixel(finder, value);
  }

  public convertFromPixel(finder: {
    seriesIndex?: number,
    seriesId?: string,
    seriesName?: string,
    geoIndex?: number,
    geoId?: string,
    geoName?: string,
    xAxisIndex?: number,
    xAxisId?: string,
    xAxisName?: string,
    yAxisIndex?: number,
    yAxisId?: string,
    yAxisName?: string,
    gridIndex?: number,
    gridId?: string
    gridName?: string
  } | string,
    // 要被转换的值，为像素坐标值，以 echarts 实例的 dom 节点的左上角为坐标 [0, 0] 点。
    value: Array<any> | string): Array<any> | string {
    return this.myECharts.convertFromPixel(finder, value);
  }

  public containPixel(finder: {
    seriesIndex?: number,
    seriesId?: string,
    seriesName?: string,
    geoIndex?: number,
    geoId?: string,
    geoName?: string,
    xAxisIndex?: number,
    xAxisId?: string,
    xAxisName?: string,
    yAxisIndex?: number,
    yAxisId?: string,
    yAxisName?: string,
    gridIndex?: number,
    gridId?: string
    gridName?: string
  } | string,
    // 要被判断的点，为像素坐标值，以 echarts 实例的 dom 节点的左上角为坐标 [0, 0] 点。
    value: Array<any>): Array<any> {
    return this.myECharts.containPixel(finder, value);
  }

  public showLoading(type?: string, opts?: Object): void {
    this.myECharts.showLoading();
  }

  public hideLoading(): void {
    this.myECharts.hideLoading();
  }

  public getDataURL(
    opts: {
      // 导出的格式，可选 png, jpeg
      type?: string,
      // 导出的图片分辨率比例，默认为 1。
      pixelRatio?: number,
      // 导出的图片背景色，默认使用 option 里的 backgroundColor
      backgroundColor?: string,
      // 忽略组件的列表，例如要忽略 toolbox 就是 ['toolbox']
      excludeComponents?: Array<string>
    }
  ): string {
    return this.myECharts.getDataURL(opts);
  }

  public getConnectedDataURL(
    opts: {
      // 导出的格式，可选 png, jpeg
      type?: string,
      // 导出的图片分辨率比例，默认为 1。
      pixelRatio?: number,
      // 导出的图片背景色，默认使用 option 里的 backgroundColor
      backgroundColor?: string,
      // 忽略组件的列表，例如要忽略 toolbox 就是 ['toolbox']
      excludeComponents?: Array<string>
    }
  ): string {
    return this.myECharts.getConnectedDataURL(opts);
  }

  public clear(): void {
    this.myECharts.clear();
  }

  public dispose(): void {
    this.myECharts.dispose();
    this.myECharts = null;
  }

  public isDisposed(): boolean {
    return this.myECharts ? this.myECharts.isDisposed() : true;
  }

}
